<section class="av-billing-method">
    <div class="av-billing-method__heading">
        <h2>{{ 'app.billing.payment_method.title' | translate }}</h2>
        <p class="av-billing-note m-0">{{ 'app.billing.payment_method.subtitle' | translate }}</p>
    </div>

    @if (isLoading()) {
    <div role="status" [attr.aria-label]="'app.billing.invoices.loading' | translate">
        <div class="av-billing-skeleton av-billing-skeleton--line"></div>
        <div class="av-billing-skeleton av-billing-skeleton--line"></div>
    </div>
    } @else {
    <div class="row g-4">
        <div class="col-12 col-md-6">
            <div class="av-billing-method-row">
                @if (hasPaymentMethod()) {
                <div class="av-billing-method-row__main">
                    <span class="av-billing-brand-tile">
                        <img class="av-billing-brand" [src]="brandSource()"
                            [alt]="'app.billing.payment_method.brand_alt' | translate: brandAltParams()" />
                    </span>

                    <span class="av-billing-method-row__label">
                        @if (hasCardDetails()) {
                        {{ 'app.billing.payment_method.card' | translate: cardParams() }}
                        } @else {
                        {{ 'app.billing.payment_method.on_file' | translate }}
                        }
                    </span>

                    @if (paymentMethod()?.exp_month) {
                    <span class="av-billing-note">{{ 'app.billing.payment_method.expires' | translate: expiryParams() }}</span>
                    }

                    @if (isExpiringSoon()) {
                    <span class="av-billing-warning">{{ 'app.billing.payment_method.expiry_warning' | translate }}</span>
                    }
                </div>
                } @else {
                <span class="av-billing-note">{{ 'app.billing.payment_method.none' | translate }}</span>
                }

                @if (!isReadOnly()) {
                <button mat-stroked-button (click)="changeCard.emit()">
                    {{ 'app.billing.actions.update_card' | translate }}
                </button>
                }
            </div>
        </div>

        <div class="col-12 col-md-6 av-billing-method-col--divided">
            <div class="av-billing-method-row">
                <div class="av-billing-method-row__main">
                    <span class="av-billing-method-row__label">{{ 'app.billing.contact.label' | translate }}</span>
                    <span class="av-billing-note">{{ billingContact() ?? '-' }}</span>
                </div>

                @if (!isReadOnly()) {
                <button mat-stroked-button (click)="changeContact.emit()">
                    {{ 'app.billing.actions.change_email' | translate }}
                </button>
                }
            </div>
        </div>
    </div>
    }
</section>
